import { createReducer } from '@reduxjs/toolkit'
import ActionTypes from '@constants/action_types.js'

export const initialState = {}

export const endpoint = createReducer(initialState, builder => {
  builder.addCase(ActionTypes.RECEIVE_ENDPOINTS, (state, action) => receiveEndpoints(state, action))
})

export default endpoint

function receiveEndpoints(state, action) {
  const { payload: endpoints } = action
  state = {
    ...state,
    ...endpoints,
  }
  return state
}
